module.exports = __webpack_public_path__ + "img/home-blue.a35b9c59.svg";